import React, { useEffect } from "react";
import { NAVER_CLIENT_ID, NAVER_CALLBACK_URL } from "./NaverConfig.js";

const NaverLogin = () => {
  useEffect(() => {
    const naverScript = document.createElement("script");
    naverScript.src = "https://static.nid.naver.com/js/naveridlogin_js_sdk_2.0.2.js";
    naverScript.async = true;
    document.head.appendChild(naverScript);

    naverScript.onload = () => {
      const naverLogin = new window.naver.LoginWithNaverId({
        clientId: NAVER_CLIENT_ID ,
        callbackUrl: NAVER_CALLBACK_URL,
        isPopup: false,
        loginButton: { color: "green", type: 3, height: 50 },
      });
      naverLogin.init();
    };
  }, []);

  return <div id="naverIdLogin" />;
};

export default NaverLogin;
